import { TweenMax, Power4 } from 'gsap';
import { disableBodyScroll } from 'body-scroll-lock';

function showMenuItems() {
  setTimeout(() => {
    TweenMax.staggerFromTo(
      '.menu__list li',
      0.3,
      {
        opacity: 0,
        ease: Power4.easeInOut
      },
      {
        opacity: 1,
        ease: Power4.easeInOut
      },
      0.03
    );
  }, 300);
}

/* eslint no-param-reassign: "error" */
function addClass(el, className) {
  if (el.classList) el.classList.add(className);
  showMenuItems();
}

const menuOpener = async () => {
  const body = document.querySelector('body');
  const el = document.querySelector('.js-header-menu-opener');
  const menu = document.querySelector('[js-menu="menu"]');

  if (!el) {
    return;
  }

  el.addEventListener('click', () => {
    addClass(body, 'isMenuOpen');
    document.documentElement.classList.add('isMenuOpen');
    disableBodyScroll(menu, {
      reserveScrollBarGap: true,
      allowTouchMove: element =>
        console.log(element.closest('[js-menu="container"]'))
    });
  });
};

export default menuOpener;
